import cRequest from "@services/c-request"

const tenantsPath = `${process.env.REACT_APP_BASE_URL}/tenants`
const emailsPath = `${process.env.REACT_APP_BASE_URL}/emails`
const uploadPath = `${process.env.REACT_APP_BASE_URL}/uploads`
const notificationsPath = `${process.env.REACT_APP_BASE_URL}/notifications`
const analyticsPath = `${process.env.REACT_APP_BASE_URL}/analytics`
const expensesPath = `${process.env.REACT_APP_BASE_URL}/expenses`
const webhookPath = `${process.env.REACT_APP_BASE_URL}/webhook`

interface GetAnalyticsServiceProps {
  start: string | Date
  end: string | Date
  previousStart?: string | Date
  previousEnd?: string | Date
  previousTwoStart?: string | Date
  previousTwoEnd?: string | Date
  previousThreeStart?: string | Date
  previousThreeEnd?: string | Date
  filterType?: string
  days?: number
  type: "admin" | "channel"
}
interface SendEmailProps {
  sender_name: string
  sender_email: "carpaddy@carpaddy.com" | "support@carpaddy.com"
  to?: string
  emails?: string[]
  subject: string
  htmlMessage: string
  imageUrl?: string
}
interface SendAppNotificationProps {
  title: string
  message: string
  type: string
}

interface SendGroupPushNotificationProps {
  data?: {
    title: string
    body: string
  }
  emails?: string[]
  group?: string
  tenantid?: string
}

interface sendExpenseServiceProps {
  title: string
  amount: number
  description: string
}

interface SendWebHookServiceProps {
  url: string
  status: string
  clientTransactionId: string
  type: "orders" | "reminders"
}

type AppMailTyeProps = "whatsapp" | "mail"

export const getAllTenantsService = async () => {
  return cRequest
    .get(`${tenantsPath}/get-all-tenants`)
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

type GetTenantServiceProps = (apikey: string, tenantid: string) => any
export const getTenantService: GetTenantServiceProps = async (
  apikey,
  tenantid
) => {
  return cRequest
    .get(`${tenantsPath}`, { params: { apikey, tenantid } })
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

type UpdateTenantServiceProps = (data: object, tenantid: string) => any
export const updateTenantService: UpdateTenantServiceProps = async (
  data,
  tenantid
) => {
  return cRequest
    .put(`${tenantsPath}`, { data, tenantid })
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const sendEmailService = async (body: SendEmailProps) => {
  return cRequest
    .post(`${emailsPath}/send-email`, body)
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const sendGroupEmailsService = async (body: SendEmailProps) => {
  return cRequest
    .post(`${emailsPath}/send-group-emails`, body)
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const countGroupPushRecipientsService = async (
  body: SendGroupPushNotificationProps
) => {
  return cRequest
    .post(`${notificationsPath}/count-group-push-recipients`, body)
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const sendGroupPushNotificationsService = async (
  body: SendGroupPushNotificationProps
) => {
  return cRequest
    .post(`${notificationsPath}/send-group-push-notifications`, body)
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const sendAppNotificationService = async (
  body: SendAppNotificationProps
) => {
  return cRequest
    .post(notificationsPath, body)
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const getAppNotificationService = async (
  type: string,
  seen: string,
  userCreatedAt: string
) => {
  return cRequest
    .get(notificationsPath, { params: { type, seen, userCreatedAt } })
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const sendOrdersEmailService = async (body: SendEmailProps) => {
  return cRequest
    .post(`${emailsPath}/send-orders-email`, body)
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const sendPasswordResetEmailService = async (body: SendEmailProps) => {
  return cRequest
    .post(`${emailsPath}/send-password-reset-email`, body)
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const uploadSingleFileService = async (file: any) => {
  const formData = new FormData()
  formData.append("image", file)

  return cRequest
    .post(`${uploadPath}/single-file`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const deleteSingleFileService = async (filename: string) => {
  return cRequest
    .delete(`${uploadPath}/delete-single-file`, { data: { filename } })
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const getAppMailsService = async (mssgType: AppMailTyeProps) => {
  return cRequest
    .get(`${emailsPath}/app-mails`, { params: { mssgType } })
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const updateAppMailService = async (body: any) => {
  return cRequest
    .put(`${emailsPath}/update-app-mail`, body)
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const getAnalyticsService = async ({
  start,
  end,
  previousStart,
  previousEnd,
  previousTwoStart,
  previousTwoEnd,
  previousThreeStart,
  previousThreeEnd,
  filterType,
  days,
  type = "admin",
}: GetAnalyticsServiceProps) => {
  return cRequest
    .get(`${analyticsPath}/${type}-analytics`, {
      params: {
        start,
        end,
        previousStart,
        previousEnd,
        previousTwoStart,
        previousTwoEnd,
        previousThreeStart,
        previousThreeEnd,
        filterType,
        days,
      },
    })
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const addExpenseService = async (body: sendExpenseServiceProps) => {
  return cRequest
    .post(expensesPath, body)
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const sendWebHookService = async (body: SendWebHookServiceProps) => {
  return cRequest
    .post(`${webhookPath}/send`, body)
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}
